import { useEffect } from "react";
import "./App.css";
import { initLenis } from "./lib/lenis";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Gallery } from "./components/Gallery";
import { WhyUs } from "./components/WhyUs";
import { News } from "./components/News";
import { Testimonials } from "./components/Testimonials";
import { Booking } from "./components/Booking";
import { Contacts } from "./components/Contacts";
import { InstagramFeed } from "./components/InstagramFeed";
import { Footer } from "./components/Footer";
import { FloatingCall } from "./components/FloatingCall";

function App() {
  useEffect(() => initLenis(), []);

  return (
    <div className="min-h-screen bg-cream font-sans text-ink antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Gallery />
        <WhyUs />
        <News />
        <Testimonials />
        <Booking />
        <Contacts />
        <InstagramFeed />
      </main>
      <Footer />
      <FloatingCall />
    </div>
  );
}

export default App;
